import { APIAdapter } from "../../../helpers/api_helper";
import axios from "axios";

  const api = new APIAdapter();

  const transaction = process.env.REACT_APP_API_TRANSACTION;

  export const addReversement = async (data, selectedBusiness) => {
    try {
      const response = axios.post(`${transaction}/manage/pay-out/create/mobile?merchant=${data?.merchantId}&business=${selectedBusiness?.id}`, data,
        {
          headers: {
            Authorization: `Bearer ${data?.token}`,
            "x-api-key": selectedBusiness?.apiKey,
            "X-API-TOKEN": selectedBusiness?.apiToken,
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const askVersementBank = async (data, selectedBusiness) => {
    try {
      const response = axios.post(`${transaction}/transaction/pay-out-bank`, data,
        {
          headers: {
            Authorization: `Bearer ${data?.token}`,
            "x-api-key": selectedBusiness?.apiKey,
            "X-API-TOKEN": selectedBusiness?.apiToken,
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getReversementByMerchandId = async (merchandId, token) => {
    try {
      const response = axios.get(`${transaction}/transfer/all/by-merchant/${merchandId, token}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const updateReversement = async (id, data) => {
    try {
      const response = await axios.put(`${transaction}/subscriptions/update/${id}`, data);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const deleteReversement = async (id, token) => {
    try {
      const response = await axios.delete(`${transaction}/subscriptions/delete/${id}`,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  };
  
  export const getBusinessByMarchandId = async (merchandId) => {
    try {
      const response = await api.get(`/developer-accounts/merchant/${merchandId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getCountryPayment = async (token) => {
    try {
    const response = await axios.get(`${transaction}/country`,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log('Country -- ', response)
    return response.data
    } catch (error) {
      throw error;
    }
  }

  export const getPaymentMethodListByCountryCode = async (countryCode, token) => {
    const response = await axios.get(`${transaction}/payment-method/country/${countryCode}`,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log('getPaymentMethodListByCountryCode -- ', response)
    return response.data;
  }

  export const getDetailCountryPerMerchant = async (props) => {
    try {
      const response = await axios.get(`${transaction}/manage/pay-out/merchant/country/countryCode=${props?.countryCode}?merchant=${props?.merchandId}`,{
        headers: {
          Authorization: `Bearer ${props?.token}`,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  };
